module.exports = __webpack_public_path__ + "static/img/2fa-config-instruction.01a8602.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2fa-config-instruction.svg
// module id = 324
// module chunks = 1